import * as React from "react";
enum UserAffiliation {
    SVV= "Statens Vegvesen",
    Fylkeskommune= "Fylkeskommune",
    Kommune = "Kommune",
    NyeVeier = "Nye veier",
    Datafangst= "Entreprenør/annen"
}

interface Props {}
interface State {
    userAffiliation?: UserAffiliation,
    helpContent?: any
}

export default class ForgotPassword extends React.Component<Props, State>{
    constructor(props: Readonly<Props>) {
        super(props);
        this.state = {};
    }
    render(){
        const chosenUserAffiliation = this.state.userAffiliation;
        const helpContent = this.state.helpContent;
        return(
            <>
                <div className={"df-radiogroup"}>
                    <legend>Velg din tilhørighet</legend>
                    <fieldset>
                        {this.UserTypeRadio(UserAffiliation.SVV)}
                        {this.UserTypeRadio(UserAffiliation.Fylkeskommune)}
                        {this.UserTypeRadio(UserAffiliation.Kommune)}
                        {this.UserTypeRadio(UserAffiliation.NyeVeier)}
                        {this.UserTypeRadio(UserAffiliation.Datafangst)}
                    </fieldset>
                </div>

                {!!chosenUserAffiliation && !!helpContent &&
                   <div className={"df-info-content"}>
                       <h4>{chosenUserAffiliation}</h4>
                       <div>
                           {helpContent}
                       </div>
                   </div>
                }
            </>
        )
    }

    UserTypeRadio(userType:UserAffiliation){
        return(<label>
            <input type="radio"
                   value={userType}
                   onChange={e => this.setChosenUserType(userType)}
                   checked={this.state.userAffiliation === userType}
            />
            <span>{userType}</span>
        </label>)
    }
    setChosenUserType(userType:UserAffiliation){
        this.setState({
            userAffiliation: userType,
            helpContent: this.getHelpContent(userType)
        })
    }
    getHelpContent(userAffiliation: UserAffiliation)  {
        switch(userAffiliation) {
            case UserAffiliation.SVV:
                return SixDigitUserForgotPassword;
            case UserAffiliation.Fylkeskommune:
                return PUserForgotPassword;
            case UserAffiliation.Kommune:
            case UserAffiliation.NyeVeier:
                return EightDigitUserForgotPassword;
            case UserAffiliation.Datafangst:
            default:
                return EmailUserForgotPassword;
        }
    }
}


const SixDigitUserForgotPassword = (
        <>
            <p>Du logger inn i Datafangst med din vegvesenbruker (sekssifret brukernavn).</p>

            <p>For glemt/nytt passord for din bruker, besøk <a href={"https://vegvesen.no/passord"}>vegvesen.no/passord</a>.</p>

            <p>Ved andre innloggingsproblemer eller feil med brukeren, kontakt brukerservicesenter (BSS) på
                24&nbsp;05&nbsp;80&nbsp;00 for brukerstøtte.</p>
        </>
    );
const PUserForgotPassword = (
        <>
            <p>Du logger inn i Datafangst med ditt brukernavn (starter på P etterfulgt av en serie tall).</p>

            <p>For glemt/nytt passord for din bruker, besøk <a href={"https://vegvesen.no/passord"}>vegvesen.no/passord</a>.</p>

            <p>Ved andre innloggingsproblemer eller feil med brukeren, kontakt din IT-avdeling.</p>
        </>
    );
const EightDigitUserForgotPassword = (
        <>
            <p>Du logger inn i Datafangst med ditt brukernavn (åtte tegn i brukernavn).</p>

            <p>Ved glemt passord, innloggingsproblemer eller feil med brukeren, kontakt Statens Vegvesens
                brukerservicesenter (BSS) på 24&nbsp;05&nbsp;80&nbsp;00.</p>
        </>
    );
const EmailUserForgotPassword = (
        <>
            <p>Du logger inn i Datafangst med din e-postadresse.</p>

            <p>Hvis du har glemt ditt passord kan du <a href={"/noauth/#!/user/resetpassword"}>sette nytt passord her</a>.</p>
        </>
    );
